import type {Relation} from "typeorm";
import {ChildEntity, Column, ManyToOne} from "typeorm";
import {StaffMember} from "@/modules/staff/entity";
import {PositionAreaEnum} from "@/modules/base/enums";
import {Player} from "@/modules/team/entity";
import {Sortable} from "@/modules/base/interfaces";

@ChildEntity('coach')
export class Coach extends StaffMember implements Sortable {
  @ManyToOne(() => Player)
  player?: Relation<Player>;

  @Column({type: "varchar", enum: PositionAreaEnum, nullable: true})
  positionArea?: PositionAreaEnum;

  get order(): number {
    return (this.positionArea ? Object.values(PositionAreaEnum).indexOf(this.positionArea) * 1000 : 0) - this.skill;
  }
}
